<template>
  <div class="step-container scrollPosition">
    <div class="step-header">
      <h2 class="step-title">Adresse</h2>
      <p class="step-text">
        Geben Sie hier die Adresse der Immobilie an, für die Sie den Richtwert
        ermitteln möchten.
      </p>
    </div>
    <div class="step-body">
      <div class="row gx-5">
        <div class="col-md-3">
          <TextField
            v-model="fields.plz.value"
            placeholder="PLZ"
            :state="fields.plz.state"
            @change="onChangePLZ()"
          />
        </div>
        <div class="col-md-9">
          <TextFieldAutocomplete
            id="auto-1"
            :options="cityDetails.map((item) => item.city)"
            v-model="fields.ort.value"
            placeholder="Ort"
            :state="fields.ort.state"
            @valueSet="onChangeOrt()"
          />
        </div>
        <div class="col-md-9">
          <TextFieldAutocomplete
            id="auto-2"
            v-model="fields.strasse.value"
            :options="streetSuggestions"
            placeholder="Straße"
            @valueSet="onChangeStrasse()"
            @inputChanged="getStreetSuggestions()"
            :state="fields.strasse.state"
          />
        </div>
        <div class="col-md-3">
          <TextField
            v-model="fields.hausnr.value"
            placeholder="Hausnummer"
            @change="
              validate('hausnr');
              getStreetSuggestions();
            "
            :state="fields.hausnr.state"
          />
        </div>
      </div>
    </div>
    <div class="step-footer">
      <div class="row align-items-center">
        <div class="col-md-4 col-6">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
        <div class="col-md-4 col-6 next-container">
          <button
            class="next-btn"
            @click="goNext()"
          >
            Weiter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TextField from "@/components/shared/TextField.vue";
import TextFieldAutocomplete from "@/components/shared/TextFieldAutocomplete.vue";
import DataService from "@/services/DataService.js";
import _ from "lodash";
import {
  getFromStorage,
  saveToStorage,
  checkValidFields,
  checkInvalidFields,
  containsInvalidFields,
  validateField,
  validatePLZ,
  validateOrt,
  validateStrasse,
} from "@/utils.js";
export default {
  name: "reihenhaus-step-1",
  components: {
    TextField,
    TextFieldAutocomplete,
},
  data() {
    return {
      fields: {
        plz: { validators: ["required"] },
        ort: { validators: ["required"] },
        strasse: { validators: ["required"] },
        hausnr: { validators: ["required"] },

      },
      cityDetails: [],
      streetSuggestions: [],
    };
  },
  methods: {
    goBack() {
      saveToStorage(this.fields);
      this.$router.push("/start");
    },
    async goNext() {
      await this.validateAddress();
      checkInvalidFields(this.fields);
      if (!containsInvalidFields(this.fields)) {
        saveToStorage(this.fields);
        this.$router.push("/reihenhaus-step-2");
      }
    },
    async validate(name) {
      const field = this.fields[name];
      field.state = validateField(field.value, field.validators);
    },
    async getCityDetails() {
      const plz = this.fields["plz"].value;
      if (plz?.length > 0) {
        const response = await DataService.getPlacesForZipCode(plz);
        if (response.status != 200) {
          console.log(
            `fetching of cityDetails failed: ${response.status} ${response.statusText}`
          );
        }
        const body = await response.json();
        if (body?.cityDetails) {
          this.cityDetails = body.cityDetails;
        }
      } else {
        this.cityDetails = [];
      }
    },
    getStreetSuggestions: _.throttle(async function () {
      const plz = this.fields["plz"].value;
      const ort = this.fields["ort"].value;
      const strasse = this.fields["strasse"].value;
      const hausnr = this.fields["hausnr"].value;
      if (plz?.length > 0 && ort?.length > 0 && strasse?.length > 0) {
        const response = await DataService.getStreetSuggestions(
          plz,
          ort,
          strasse,
          hausnr
        );
        if (response.status != 200) {
          console.log(
            `fetching of street suggestions failed: ${response.status} ${response.statusText}`
          );
        }
        const body = await response.json();
        if (body?.streets) {
          this.streetSuggestions = body.streets;
        }
      } else {
        this.streetSuggestions = [];
      }
    }, 2000),
    async onChangePLZ() {
      await this.getCityDetails();
      validatePLZ(this.fields, this.cityDetails);
      validateOrt(this.fields, this.cityDetails);
      await this.getStreetSuggestions();
      validateStrasse(this.fields, this.streetSuggestions);
    },
    async onChangeOrt() {
      validateOrt(this.fields, this.cityDetails);
      await this.getStreetSuggestions();
      validateStrasse(this.fields, this.streetSuggestions);
    },
    async onChangeStrasse() {
      validateStrasse(this.fields, this.streetSuggestions);
    },
    async validateAddress() {
      await this.getCityDetails();
      validatePLZ(this.fields, this.cityDetails);
      validateOrt(this.fields, this.cityDetails);
      await this.getStreetSuggestions();
      validateStrasse(this.fields, this.streetSuggestions);
    },
  },
  async mounted() {
    this.$emit("setStep", "reihenhaus", 2);
    getFromStorage(this.fields);
    await this.validateAddress();
    checkValidFields(this.fields);
  },
};
</script>
<style scoped>
.step-body .row {
  row-gap: 45px;
}
@media only screen and (max-width: 768px) {
  .step-body .row {
    row-gap: 30px;
  }
}
</style>
